const RevenueSpendByTeamPageLangKey = [
	'btn_show_empty_spend_agency_columns',
	'btn_hide_empty_spend_agency_columns'
] as const

type IRevenueSpendByTeamPageLangKey = typeof RevenueSpendByTeamPageLangKey[number]

export type IRevenueSpendByTeamPageLang = {
	revenue_spend_by_team_page: Record<IRevenueSpendByTeamPageLangKey, string>
}

const langEntries = RevenueSpendByTeamPageLangKey.map(
	(key: IRevenueSpendByTeamPageLangKey) => [key, `revenue_spend_by_team_page.${key}`]
)

const langObj: Record<IRevenueSpendByTeamPageLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_TEAM_PAGE_LANG_KEY: IRevenueSpendByTeamPageLang = {
	revenue_spend_by_team_page: langObj
}
